<template>
    <div style="max-width: 600px; margin: auto; text-align: left;">
        <FieldHeader :field="field" />
        <q-input filled dense :model-value="modelValue" :readonly="readOnly" :list="listId"
            @update:model-value="$emit('update:modelValue', $event)" @blur="$emit('blur')" />
        <datalist :id="listId">
            <option v-for="name in field.options?.suggestions || []" :key="name" :value="name" />
        </datalist>
    </div>
</template>
<script>
import FieldHeader from './FieldHeader.vue';
export default {
    name: 'StaffNameField', components: { FieldHeader },
    props: { field: Object, modelValue: { type: String, default: '' }, readOnly: Boolean },
    emits: ['update:modelValue', 'blur'],
    computed: { listId() { return `staff-names-${this.field.id}`; } },
};
</script>
